import React from 'react'
import { withState, compose, shouldUpdate } from 'recompose'
import { Helmet } from 'react-helmet'

import LotsList from './LotList/index'
import Categories from './Categories'

const categoryClick = handler => (name, e) => {
  e && e.preventDefault()
  handler(name)
}

const Persons = ({ categories = [], setCategory, category, meta }) => (
  <div className='Persons'>
    <div className='Container'>
      <Helmet>
        <title>{meta.name}</title>
        <meta name='description' content={meta.description} />
        <meta property='og:title' content={meta.name} />
        <meta property='og:image' content={meta.image} />
        <meta property='og:url' content={window.location.href} />
        <meta property='og:description' content={meta.description} />
      </Helmet>
      <Categories type='lots' onClick={categoryClick(setCategory)} typelot={'lots'} current={category || null} classPrefix='Persons' withAll />

      {/* TODO: lots <LotsList params={{ category }} limit={3} type={'closingSoon'} title={'Скоро заканчиваются'} containerClass='Persons__list' /> */}

      {/* TODO: lots <LotsList params={{ category }} limit={3} type={'bids'} title={'Самые дорогие'} /> */}

      {/* TODO: lots title={'Недавно добавленные'} */}
      <LotsList params={{ category }} limit={50} type={'newPublished'}  typelot={'lots'} containerClass='Persons__list' project={'5fe18eab1a0b3d20e0fff6cb'} listName={'Аукционы'} expandable />
    </div>
  </div>
)

export default compose(
  withState('category', 'setCategory', null),
  shouldUpdate((props, np) => (np.category !== props.category))
)(Persons)



// WEBPACK FOOTER //
// ./src/containers/Lots.jsx